import { createFileRoute } from '@tanstack/react-router'

import { VoipPage } from '#/modules/communication/voip-page'
import { validateListSearch } from '#/shared/lib/list-search'

export const Route = createFileRoute('/_shell/voip')({
  component: VoipPage,
  validateSearch: validateListSearch,
})
